import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms/';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LoggerService } from './lib/services/logger/logger.service';
import { ContextService } from './lib/services/context/context.service';
import { DataService } from './lib/services/data/data.service';
import { DictStorageService } from './lib/services/dict-storage/dict-storage.service';
import { FetchService } from './lib/services/fetch/fetch.service';
import { ScrollService } from './lib/services/scroll/scroll.service';
import { StorageService } from './lib/services/storage/storage.service';
import { LanguageService } from './lib/services/lang/language.service';
import { LangInterceptorService } from './lib/services/lang/lang-interceptor.service';

//Modules
import { CoreModule, ServicesModule } from 'world-archery-lib';
import { InterprationPageComponent } from './pages/interpration-page/interpration-page.component';
import { TabsPageComponent } from './pages/tabs-page/tabs-page.component';
import { InterpretationDetailComponent } from './lib/components/interpretation-detail/interpretation-detail.component';
import { InterpretationRowComponent } from './lib/components/interpretation-row/interpretation-row.component';
import { FiltersInterpretationService } from './lib/services/interpretation-service/filters-interpretation-service.service';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';
//import { BrowserAnimationsModule } from '@angular/core'
import { CacheInterceptorService } from '../library/components/services/interceptors/cache-interceptor.service';
import { CommonRulebookComponentsModule } from './common-rulebook-components.module';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    CommonRulebookComponentsModule,
    FormsModule,
    CommonPageComponentsModule,
    CoreModule,
    ServicesModule
  ],
  providers: [
    LoggerService,
    ContextService,
    ScrollService,
    DataService,
    StorageService,
    FiltersInterpretationService,
    FetchService,
    DictStorageService,
    { provide: HTTP_INTERCEPTORS, useClass: LangInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptorService, multi: true },
    LanguageService,
    FiltersInterpretationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
